import { useRef } from 'react';
import { useAccordionContext } from '../context';
import { IAccordionItemButton } from './DefaultAccordionItemButton';

export function useIsChecked(
  props: IAccordionItemButton,
): [boolean, (isChecked: boolean) => void] {
  const handler = useAccordionContext();
  const isChecked = handler.hooks.useItemStateSelector(
    (current) => current.isChecked,
  );
  const id = handler.hooks.useItemId();

  const previousPropsChecked = useRef(props.checked);
  if (
    previousPropsChecked.current !== props.checked &&
    props.checked !== undefined
  ) {
    previousPropsChecked.current = props.checked;
    handler.udpateItem(id, { isChecked: props.checked });
  }

  return [
    isChecked,
    (isChecked) => {
      handler.udpateItem(id, { isChecked });
      props.onChange?.(isChecked);
    },
  ];
}
